import { MODULE_NAME } from './const';
import StoreModuleService from '../StoreModuleService';

const buildEdgesGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const useEdge = buildEdgesGetterObject('useEdge');
export const useEdges = buildEdgesGetterObject('useEdges');
export const useEdgesList = buildEdgesGetterObject('useEdgesList');
export const useNodeEdges = buildEdgesGetterObject('useNodeEdges');
export const useWorkflowVersionEdges = buildEdgesGetterObject('useWorkflowVersionEdges');

const getters = {
	[useEdges.getter]: (state) => state.data,
	[useEdge.getter]: (state, getters) => (id) => getters[useEdges.getter][id],
	[useEdgesList.getter]: (state, getters) => Object.values(getters[useEdges.getter]),
	[useNodeEdges.getter]: (state, getters) => (nodeId) =>
		getters[useEdgesList.getter].filter((edge) => edge.source === nodeId || edge.target === nodeId),
	[useWorkflowVersionEdges.getter]: (state, getters) => (workflowVersionId) =>
		getters[useEdgesList.getter].filter((edge) => edge.workflow_version === workflowVersionId),
};

export default getters;
